export const LAST_CHAT_TIMESTAMP_KEY = "lastChatTimestamp";
export const LAST_CHAT_TIMESTAMP_CHANGED_EVENT = "lastChatTimestampChanged";
